import React, { Component } from 'react'
import { Redirect, Link } from 'react-router-dom'
import ReactGA from 'react-ga'
import { withStyles } from '@material-ui/core/styles'
import {
  withWidth,
  Paper,
  Grid,
  TextField,
  Button,
  ClickAwayListener,
  InputAdornment,
  CircularProgress,
  Typography,
  Hidden
} from '@material-ui/core'
import _ from 'lodash'
import { connect } from 'react-redux'
import {
  authenticateUser,
  checkLoggedin,
  getLoginProviderMethodForUser,
  verifyAndSendToken,
  setNeedVerify,
  forgotPassword
} from '../actions/users'
import queryString from 'query-string'
import colors from '../helpers/color.helper'
import util from '../helpers/util.helper'
import EnvelopeIcon from 'calcite-ui-icons-react/EnvelopeIcon'
import LockIcon from 'calcite-ui-icons-react/LockIcon'
import { VisibilityOutlined, VisibilityOffOutlined, Info, Check } from '@material-ui/icons'
import TempCodeVerification from './tempCodeVerifcation'
import { Modal } from 'swx-atomic-component-lib'
import i18n from '../i18n'

const styles = theme => ({
  container: {
    overflow: 'hidden',
    display: 'flex',
    backgroundImage: 'url(/shapes-lines-large.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'calc(50% - 257px) calc(50% - 214px)',
    [theme.breakpoints.down('sm')]: {
      minHeight: 450,
      backgroundSize: '1104.75px 1089.75px'
    },
    [theme.breakpoints.up('sm')]: {
      minHeight: 760
    },
    [theme.breakpoints.down('xs')]: {
      backgroundSize: '736.5px 726.5px',
      backgroundPosition: 'top right',
      minHeight: '100vh',
      paddingTop: 'env(safe-area-inset-top)',
      paddingBottom: 'env(safe-area-inset-bottom)',
      position: 'relative',
      width: '100vw',
      maxWidth: '100vw'
    }
  },
  form: {
    flex: 1,
    flexWrap: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      paddingTop: '8vh',
      paddingBottom: '2vh',
      minHeight: '100vh',
      justifyContent: 'center'
    }
  },
  logo: {
    position: 'absolute',
    [theme.breakpoints.up('lg')]: {
      top: '20vh',
      left: '11vw',
      height: 51,
      width: 235
    },
    [theme.breakpoints.down('lg')]: {
      top: '19.53125vh',
      left: '14.71449487554905vw',
      height: 51,
      width: 235
    },
    [theme.breakpoints.down('md')]: {
      top: '13.15789473684211vh',
      left: '9.84375vw',
      height: 38.3,
      width: 176.3
    },
    [theme.breakpoints.down('sm')]: {
      top: '8.333333333333333vh',
      left: '9.475vw',
      height: 38.3,
      width: 176.3
    },
    [theme.breakpoints.down('xs')]: {
      position: 'inherit',
      height: 38.3,
      width: 176.3,
      marginBottom: '2vh'
    }
  },
  paper: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    },
    width: 480,
    background: 'none',
    boxShadow: 'none',
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100vw - 32px)',
      maxWidth: 295,
      margin: '0 16px',
      marginTop: '-10px'
    }
  },
  welcome: {
    color: colors.blue
  },
  envelope: {
    position: 'relative',
    bottom: -44,
    left: -36,
    [theme.breakpoints.down('xs')]: {
      left: 20,
      bottom: -44,
      zIndex: 100
    }
  },
  lock: {
    position: 'relative',
    bottom: 40,
    left: -36,
    [theme.breakpoints.down('xs')]: {
      left: 20,
      bottom: 105
    }
  },
  successLock: {
    [theme.breakpoints.down('xs')]: {
      marginTop: 18,
      left: 20
    }
  },
  link: {
    textDecoration: 'none',
    color: colors.blue
  },
  login: {
    // marginLeft: 69,
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
      marginTop: 20
    }
  },
  visibility: {
    opacity: 0.5,
    height: 16,
    width: 16
  },
  icon: {
    height: 16,
    width: 16
  },
  email: {
    [theme.breakpoints.down('xs')]: {
      '& input': {
        paddingLeft: 48
      }
    }
  },
  emailError: {
    [theme.breakpoints.down('xs')]: {
      '& input': {
        paddingLeft: 48
      }
    },
    '& input': {
      boxShadow: 'none !important',
      border: `1px solid ${colors.error}`,
      '&:focus': {
        boxShadow: `0 0 0 1px ${colors.error} !important`
      }
    }
  },
  password: {
    [theme.breakpoints.down('xs')]: {
      '& input': {
        paddingLeft: 48
      }
    }
  },
  passwordFocused: {
    [theme.breakpoints.down('xs')]: {
      '& input': {
        paddingLeft: 48
      }
    },
    '& input': {
      color: `${colors.blue} !important`
    }
  },
  loading: {
    color: colors.white,
    height: '16px !important',
    width: '16px !important'
  },
  success: {
    height: 48,
    width: 48,
    backgroundColor: colors.success,
    borderRadius: '50%'
  },
  tick: {
    height: 24,
    width: 24,
    color: colors.white,
    margin: 12
  },
  containerPassword: {
    justifyContent: 'space-between',
    flexWrap: 'no-wrap'
  },
  textContainer: {
    display: 'block',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      justifyContent: 'space-between',
      '& div': {
        flex: '0 0 auto'
      }
    }
  },
  magicCodeModalCustomStyle: {
    maxWidth: '95vw !important',
    backgroundColor: 'white'
  },
  mobileFormField: {
    [theme.breakpoints.down('xs')]: {
      '& .MuiInputBase-root': {
        fontSize: '16px' // Prevents zoom on iOS
      }
    }
  },
  mobileContainer: {
    [theme.breakpoints.down('xs')]: {
      // width: '100%',
      // maxWidth: '100%',
      paddingTop: '14vh',
      boxSizing: 'border-box'
    }
  },
  mobileGrid: {
    [theme.breakpoints.down('xs')]: {
      // width: '100%',
      // maxWidth: '100%',
      margin: 0,
      padding: 0
    }
  }
})

class Login extends Component {
  state = {
    initial: true,
    email: null,
    password: null,
    userId: null,
    isRedirecting: false,
    redirectTo: null,
    focusedOnPassword: false,
    openMagicModal: false,
    disableButton: false,
    formError: {},
    isMobileDevice: false
  }

  constructor (props) {
    super(props)
    this.classes = props.classes
  }

  handleOnCheckLoginProviderForEmail = () => {
    const { email } = this.state
    if (email) {
      const validEmail = util.validateEmail(email)
      if (validEmail) {
        this.setState({ disableButton: false })
        this.props.getLoginProviderMethodForUser(this.state.email)
      } else {
        this.setState({
          disableButton: true,
          formError: { field: 'email', message: i18n.loginPage.error.email }
        })
      }
    }
  }

  onSubmit = (e, isAskingForPassword) => {
    ReactGA.event({ category: 'Authentication', action: 'Sign in', label: 'Login page' })
    e.preventDefault()
    if (this.props.isProcessing) {
      return
    }
    if (_.isUndefined(isAskingForPassword)) {
      this.handleOnCheckLoginProviderForEmail()
    }
    if (_.isEmpty(this.state.password)) {
      return this.setState({ formError: { field: 'password', message: i18n.loginPage.error.password } })
    }

    this.setState({ isSubmitted: true, disableButton: true })
    const email = _.isEmpty(_.trim(this.state.email)) ? document.getElementById('email').value : this.state.email
    const password = _.isEmpty(_.trim(this.state.password)) ? document.getElementById('password').value : this.state.password
    this.props.authenticateUser(email, password, this.props.location.search)
  }

  handleOnChange = (e) => {
    const state = this.state
    state[e.target.name] = e.target.value
    state.disableButton = false
    if (e.target.name === 'email') {
      state.formError = {}
    }
    this.setState(state)
  }

  onForgotPasswordClick = (e) => {
    e.preventDefault()
    this.setState({ redirectTo: '/forgot' })
  }

  componentDidMount () {
    // Add window resize listener for better mobile detection
    this.handleResize = this.handleResize.bind(this)
    window.addEventListener('resize', this.handleResize)

    // Set initial mobile device state
    this.setState({ isMobileDevice: this.isMobile() })

    const params = queryString.parse(this.props.location.search)

    let isLoggedIn = false
    this.props.checkLoggedin().then(() => {
      isLoggedIn = true
    }, err => {
      console.log(err)
      isLoggedIn = false
    }).then(() => {
      if (isLoggedIn && this.props.user) {
        if (!this.props.user.is_verified) {
          return this.props.setNeedVerify(true)
        }

        if (this.props.user.is_force_reset_password) {
          window.location.href = util.forwardClientQueryStringToPath('/password/update', this.props.location.search)
          return
        }

        if (params.clientId) {
          this.props.verifyAndSendToken(params.clientId).then(() => {
            if (this.props.siteApplication && !_.isEmpty(this.props.siteApplication)) {
              if (this.props.siteApplication.postCallbackUrl) {
                const form = document.createElement('form')
                document.body.appendChild(form)
                form.method = 'POST'
                form.action = this.props.siteApplication.postCallbackUrl

                const tokenInput = document.createElement('input')
                tokenInput.name = 'token'
                tokenInput.type = 'hidden'
                tokenInput.value = this.props.self.token
                form.appendChild(tokenInput)
                if (params.return) {
                  const returnInput = document.createElement('input')
                  returnInput.name = 'returnPath'
                  returnInput.type = 'hidden'
                  returnInput.value = decodeURIComponent(params.return)
                  form.appendChild(returnInput)
                }
                form.submit()

                return
              }
              let returnURL = decodeURIComponent(params.return || this.props.siteApplication.callbackUrl)
              if (returnURL.indexOf('?') > -1) {
                returnURL += '&'
              } else {
                returnURL += '?'
              }
              returnURL += `token=${this.props.self.token}`

              if (params.seq) { returnURL += `&seq=${params.seq}` }

              const finalURL = `${this.props.siteApplication.baseUrl}${returnURL}`
              window.parent.postMessage({ action: 'completed', redirectURL: finalURL }, process.env.REACT_APP_POSTMESSAGE_WHITELIST_URL)
              window.location.href = finalURL
              this.setState({ isRedirecting: true })
            }
          }, err => {
            console.log(err)
          })
        } else {
          this.setState({ isAuthenticated: true })
        }
      } else {
        if (this.props.self) {
          this.props.self.error = null
        }
        this.setState({ email: params.email })
      }
    })
  }

  componentDidUpdate (nextProps) {
    if (nextProps.needVerify !== this.props.needVerify && nextProps.needVerify) {
      this.setState({ openMagicModal: true })
    }

    if (nextProps.user && nextProps.user.id !== this.state.userId) {
      this.setState({ userId: nextProps.user.id })
    }
  }

  onFacebookButtonClick = (e) => {
    e.preventDefault()
    window.addEventListener('message', this.handleFacebookCallback, false)

    const height = 550
    const width = 700
    const ypos = (window.screen.availTop + (window.screen.availHeight / 2)) - (height / 2)
    const xpos = (window.screen.availLeft + (window.screen.availWidth / 2)) - (width / 2)
    window.open(`auth/facebook-start.html?${process.env.REACT_APP_IDENTITY_API_HOST}/auth/facebook`, 'Signin', `width=${width},height=${height},toolbar=0,scrollbars=0,status=0,resizable=0,location=0,menuBar=0,left=${xpos},top=${ypos}`)
  }

  handleFacebookCallback = (event) => {
    if (event.origin !== window.location.origin || !event.data || event.data.source !== 'swx-identity-facebook-callback') {
      return
    }
    window.removeEventListener('message', this.handleFacebookCallback, false)
    if (event.data.error) {
      console.error('Facebook: Something went wrong', event.data.error)
    } else {
      console.log('Facebook: Successfully logged in')
      const params = queryString.parse(this.props.location.search)
      if (params.clientId) {
        this.props.verifyAndSendToken(params.clientId).then(() => {
          if (this.props.siteApplication && !_.isEmpty(this.props.siteApplication)) {
            const newQs = `token=${this.props.self.token}`
            window.location.href = `${this.props.siteApplication.baseUrl}${params.return || this.props.siteApplication.callbackUrl}?${newQs}`
            this.setState({ isRedirecting: true })
          }
        }, err => { console.log(err) })
      } else {
        this.setState({ isAuthenticated: true })
      }
    }
  }

  onLinkedInButtonClick = (e) => {
    e.preventDefault()
    window.addEventListener('message', this.handleLinkedInCallback, false)

    const height = 550
    const width = 700
    const ypos = (window.screen.availTop + (window.screen.availHeight / 2)) - (height / 2)
    const xpos = (window.screen.availLeft + (window.screen.availWidth / 2)) - (width / 2)
    console.log(`auth/linkedin-start.html?${process.env.REACT_APP_IDENTITY_API_HOST}/auth/linkedin`)
    window.open(`auth/linkedin-start.html?${process.env.REACT_APP_IDENTITY_API_HOST}/auth/linkedin`, 'Signin', `width=${width},height=${height},toolbar=0,scrollbars=0,status=0,resizable=0,location=0,menuBar=0,left=${xpos},top=${ypos}`)
  }

  handleLinkedInCallback = (event) => {
    if (event.origin !== window.location.origin || !event.data || event.data.source !== 'swx-identity-linkedin-callback') {
      return
    }
    window.removeEventListener('message', this.handleLinkedInCallback, false)
    if (event.data.error) {
      console.error('LinkedIn: Something went wrong', event.data.error)
    } else {
      console.log('LinkedIn: Successfully logged in')
      const params = queryString.parse(this.props.location.search)
      if (params.clientId) {
        this.props.verifyAndSendToken(params.clientId).then(() => {
          if (this.props.siteApplication && !_.isEmpty(this.props.siteApplication)) {
            const newQs = `token=${this.props.self.token}`
            window.location.href = `${this.props.siteApplication.baseUrl}${params.return || this.props.siteApplication.callbackUrl}?${newQs}`
            this.setState({ isRedirecting: true })
          }
        }, err => { console.log(err) })
      } else {
        this.setState({ isAuthenticated: true })
      }
    }
  }

  handleClickAway = () => {
    this.setState({
      focusedOnPassword: false
    })
  }

  handleOnSetFocusPassword = () => {
    this.setState({
      focusedOnPassword: true
    })
  }

  handleClickShowPassword = () => {
    ReactGA.event({ category: 'Authentication', action: 'Clicked Show password icon', label: 'Login page' })
    this.setState(state => ({ showPassword: !state.showPassword }))
  }

  closeModal = () => {
    this.setState({ openMagicModal: false })
  }

  handleOnRequestMagicCode = (e) => {
    ReactGA.event({ category: 'Authentication', action: 'Clicked Request magic code', label: 'Login page' })
    e.preventDefault()
    e.stopPropagation()
    const { email } = this.state
    if (_.isEmpty(_.trim(email))) {
      return this.setState({ formError: { field: 'email', message: i18n.loginPage.error.email } })
    }
    this.props.forgotPassword({ email }).then(() => {
      this.setState({ openMagicModal: true })
    }, err => {
      this.setState({ errors: err })
    })
  }

  isMobile = () => {
    // More robust mobile detection
    const isMobileByWidth = _.isEqual(this.props.width, 'xs')
    const isMobileByScreen = window.innerWidth <= 600
    const isMobileByUserAgent = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

    return isMobileByWidth || isMobileByScreen || isMobileByUserAgent
  }

  redirectToProviderURL = () => {
    const { provider } = this.props
    const query = window.location.search
    window.location.href = provider.loginURL + query
  }

  redirectToHome = () => {

  }

  handleResize = () => {
    // Update mobile device state on resize
    this.setState({ isMobileDevice: this.isMobile() })
  }

  componentWillUnmount () {
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize)
    }
  }

  render () {
    const { classes, error, isCheckingServiceProvider, isAskingForPassword, provider, isProcessing, location, authSucceeded, badCredentials, needVerify } = this.props
    const { isRedirecting, isAuthenticated, redirectTo, isSubmitted, initial, showPassword, focusedOnPassword, disableButton, openMagicModal, password, email, formError, userId } = this.state

    const isMobile = this.state.isMobileDevice || this.isMobile()

    if (isRedirecting) {
      return (i18n.loginPage.loading)
    }
    if (isAuthenticated) {
      return <Redirect to='/appLauncher' />
    }

    if (redirectTo) {
      return <Redirect to={{ ...location, pathname: redirectTo }} />
    }

    return (
      <div
        id='login'
        className={classes.container}
      >
        <Grid
          container
          spacing={0}
          className={`${classes.form} ${classes.mobileContainer}`}
          alignItems='center'
          direction='column'
          justify='center'
        >
          <Grid item container justify='center' className={classes.mobileGrid}>
            <Link to='/'><img src='black.svg' alt='SmarterWX Identity Logo' className={classes.logo} /></Link>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4} className={classes.mobileGrid}>
            <Paper
              elevation={4}
              className={classes.paper}
            >
              <Grid container direction='row' style={{ marginBottom: 32 }}>
                <Hidden only='xs'>
                  <Typography variant='h6' className={classes.welcome}>{i18n.loginPage.welcome}.</Typography>
                  <span>&nbsp;&nbsp;</span>
                  <Typography variant='h6'>{i18n.loginPage.title}</Typography>
                </Hidden>
              </Grid>
              <Grid container direction='row' style={{ height: 16 }}>
                {
                  provider && provider.loginURL && (
                    setTimeout(this.redirectToProviderURL, 1000)
                  ) &&
                    <Typography color='error'>{i18n.loginPage.providerLoading}</Typography>
                }
                {
                  !_.isEmpty(formError) && !badCredentials && (
                    <Typography color='error'>{formError.message}<span>&nbsp;&nbsp;</span></Typography>
                  )
                }
                {
                  error && isSubmitted && (
                    <Typography color='error'>{error.message}<span>&nbsp;&nbsp;</span></Typography>
                  )
                }
              </Grid>
              <form onSubmit={e => this.onSubmit(e, isAskingForPassword)}>
                <EnvelopeIcon
                  className={classes.envelope}
                  color={badCredentials || (formError && (formError.field === 'email')) ? colors.error : colors.blue}
                  size={16}
                />
                <TextField
                  InputProps={{ readOnly: Boolean(queryString.parse(location.search).email) }}
                  id='email'
                  name='email'
                  onChange={this.handleOnChange}
                  onBlur={this.handleOnCheckLoginProviderForEmail}
                  placeholder={isMobile ? null : i18n.loginPage.emailPlaceholder}
                  margin='normal'
                  autoComplete='email'
                  fullWidth
                  value={queryString.parse(location.search).email}
                  disabled={isCheckingServiceProvider}
                  className={`${!_.isEmpty(formError) && formError.field === 'email' ? classes.emailError : classes.email} ${classes.mobileFormField}`}
                />
                <br />
                <Grid
                  className={classes.containerPassword} container alignItems='center'
                  direction={isMobile ? 'column' : 'row'}
                >
                  {
                    (isAskingForPassword || initial)
                      ? (
                        <ClickAwayListener onClickAway={this.handleClickAway}>
                          <TextField
                            InputProps={{
                              endAdornment: !_.isEmpty(password)
                                ? (
                                  <InputAdornment
                                    position='end' aria-label='Toggle password visibility'
                                    onClick={this.handleClickShowPassword}
                                  >
                                    {showPassword
                                      ? <VisibilityOutlined className={classes.visibility} />
                                      : <VisibilityOffOutlined className={classes.visibility} />}
                                  </InputAdornment>
                                  )
                                : null
                            }}
                            id='password'
                            name='password'
                            onChange={this.handleOnChange}
                            onKeyPress={this.handleOnSetFocusPassword}
                            margin='normal'
                            fullWidth={isMobile}
                            type={showPassword ? 'text' : 'password'}
                            placeholder={(isMobile || focusedOnPassword) ? null : i18n.loginPage.passwordPlaceholder}
                            autoComplete='password'
                            className={`${(focusedOnPassword || !_.isEmpty(password)) && !showPassword ? classes.passwordFocused : classes.password} ${classes.mobileFormField}`}
                          />
                        </ClickAwayListener>
                        )
                      : (<div><Info className={classes.icon} /></div>)
                  }
                  {
                    authSucceeded === true && (
                      <div className={classes.success}>
                        <Check className={classes.tick} />
                      </div>
                    )
                  }
                  {
                    _.isEmpty(authSucceeded) && authSucceeded !== true && (
                      <Button
                        color='primary'
                        variant='contained'
                        type='submit'
                        className={classes.login}
                        fullWidth={isMobile}
                        disabled={disableButton || _.isBoolean(isAskingForPassword) ? !isAskingForPassword : false}
                      >
                        {
                          isProcessing ? <span>{i18n.loginPage.button.normalLoading}&nbsp;</span> : isCheckingServiceProvider ? <span>{i18n.loginPage.button.providerLoading}&nbsp;</span> : i18n.loginPage.button.default
                        }
                        {
                          (isProcessing || isCheckingServiceProvider) && <CircularProgress className={classes.loading} />
                        }
                      </Button>
                    )
                  }
                </Grid>
                <LockIcon
                  className={`${classes.lock} ${authSucceeded === true ? classes.successLock : ''}`}
                  color={badCredentials ? colors.error : colors.blue} size={16}
                />
              </form>
              <div className={classes.textContainer}>
                <div>
                  <Typography
                    style={{ marginBottom: isMobile ? 0 : 20 }}
                    variant='body2'
                    className={classes.link}
                  >
                    <Link
                      to={{ pathname: '/login', search: location.search }}
                      onClick={this.handleOnRequestMagicCode}
                      className={classes.link}
                    >
                      {i18n.common.magicCodeLink}
                    </Link>
                  </Typography>
                  <Modal className={classes.magicCodeModalCustomStyle} open={openMagicModal}>
                    <TempCodeVerification id={userId} email={email} closeModal={this.closeModal} location={location} needVerify={needVerify} />
                  </Modal>
                </div>
                <div>
                  <Typography variant='body2'>
                    <Link
                      to={{ pathname: '/forgot', search: location.search }}
                      className={classes.link}
                    >
                      {i18n.loginPage.forgetPasswordLink}
                    </Link>
                  </Typography>
                </div>
              </div>

              {/* <Grid container spacing={0} direction={this.isMobile() ? 'row' : 'column'}> */}
              {/* <Grid item> */}
              {/* <Typography style={{ marginBottom: this.isMobile() ? 0 : 20 }} variant='body2' */}
              {/* onClick={this.onRequestMagicCode} className={classes.link}><Link */}
              {/* to={{ pathname: '/login', search: location.search }} className={classes.link}>Request magic */}
              {/* code</Link></Typography> */}
              {/* { */}
              {/*! this.isMobile() && <Modal open={openMagicModal}> */}
              {/* <TempCodeVerifyForm email={email} closeModal={this.closeModal} location={location}/> */}
              {/* </Modal> */}
              {/* } */}
              {/* </Grid> */}
              {/* <Grid container={this.isMobile()} xs={6} item justify={this.isMobile() ? 'flex-end' : 'flex-start'}> */}
              {/* <Typography variant='body2'><Link */}
              {/* to={{ pathname: '/forgot', search: location.search }} className={classes.link}>Can't sign in?</Link></Typography> */}
              {/* </Grid> */}
              {/* /!* <Grid item xs={12} sm={6} md={6}> */}
              {/* <Typography variant='body2'>Don't have an account? <Link to={{ pathname: '/register', search: this.props.location.search }}>Register</Link></Typography> */}
              {/* </Grid> *!/ */}
              {/* </Grid> */}
            </Paper>
          </Grid>
        </Grid>
      </div>
    )
  }
}

const LoginComponent = withStyles(styles)(withWidth()(Login))

function mapStateToProps (state) {
  const { provider, error, isCheckingServiceProvider, isProcessing, user, authSucceeded, siteApplication, needVerify } = state.self
  const isAskingForPassword = provider && provider.provider === 'LOCAL'
  const badCredentials = error && _.startsWith(error.message, i18n.loginPage.error.invalid)
  return {
    self: state.self,
    isAskingForPassword,
    provider,
    error,
    isCheckingServiceProvider,
    isProcessing,
    user,
    authSucceeded,
    needVerify,
    siteApplication,
    badCredentials
  }
}

// Promote Login from a component to a container - it needs to know about this new dispatch method.
export default connect(mapStateToProps, {
  authenticateUser,
  checkLoggedin,
  getLoginProviderMethodForUser,
  verifyAndSendToken,
  setNeedVerify,
  forgotPassword
})(LoginComponent)
